import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='social-media-guidelines'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'
          align='center'>
          Social Media Guidelines
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual has a presence on various social media sites including Facebook, YouTube, LinkedIn and Twitter.
          While we have a presence on these sites, they are hosted by third parties with their own privacy policies, security
          policies and terms of use. We do not control or endorse any advertising, messages, content, or links published by these
          third parties. Northwestern Mutual&#39;s social media sites are open to the public and may include Northwestern Mutual employees,
          advisors, representatives, clients and their families. Any postings by any entity other than Northwestern Mutual are of those
          persons&#47;entities submitting them and do not necessarily reflect the position or opinion of Northwestern Mutual. As a member of
          a highly regulated industry, Northwestern Mutual reserves the right to remove any posts and block any followers.
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual&#39;s social media sites are intended to provide general information and encourage interaction within the community.
          We are not providing investment or tax advice on these sites, and nothing posted by us should be construed as a recommendation to or
          an offer to buy any particular product or service. Additionally, while we occasionally provide links to third&#45;party content that we
          believe our followers may find interesting, the linked sites are neither endorsed by nor under Northwestern Mutual&#39;s control &#40;unless
          otherwise noted&#41; and we are not responsible for the accuracy or completeness of the content or any changes or updates made to the third&#45;party sites.
        </Typography>
        <Typography nextElement='typography'>
          If you utilize Northwestern Mutual&#39;s social media sites, we ask that you:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: <>Use good judgment when posting comments. Don&#39;t post comments that can be viewed as offensive, inappropriate, defamatory, untruthful, harassing, threatening, stalking, discriminatory, abusive, or profane.</> },
            { bulletText: 'Do not post any personal, account, or financial information anywhere.' },
            { bulletText: 'Avoid discussing specific insurance or investment products, investment advice, or trading strategies, or producers.' },
            { bulletText: 'Not attach copyrighted or other protected material unless you own or control those rights.' },
          ]}
        />
        <Typography nextElement='typography'>
          For information regarding Northwestern Mutual&#39;s privacy practices please refer to&#160;
          <Link
            id='social-media-guidelines-policy-link'
            variant='primaryDeemphasize'
            linkUrl='/privacy-notices/'>
            our privacy policy
          </Link>
        </Typography>
        <Typography nextElement='typography'>
          If you are a client and have specific questions related to your policy or account, please follow this link:&#160;
          <Link
            id='social-media-guidelines-contact-link'
            variant='primaryDeemphasize'
            linkUrl='/contact-us/'>
            Contact Us
          </Link>.
        </Typography>
        <Typography disableBottomPadding>
          Northwestern Mutual&#39;s social media sites are not intended as a solicitation in any jurisdiction in which Northwestern Mutual or any of its
          subsidiaries are not authorized to transact business.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
